import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  margin-bottom: 30px;
  justify-content: space-between;
  padding-right: 12px;
  margin-right: 12px;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.sectionTitle};
`;
Title.displayName = 'Title';
